module.exports = __webpack_public_path__ + "img/female7.3dffe855.jpg";